// extracted by mini-css-extract-plugin
export var compactFilters = "_bq-4";
export var detailImage = "_bq-1";
export var dropdownContainer = "_bq-2";
export var imageContainer = "_bq-0";
export var selectedCard = "_bq-3";